/**
 * Registers the NavigationObstacle2D parser. It reuses the Node2D parse, and its property
 * knowledge lives in linterParser.ts.
 */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseNode2D } from '../../base/node2d/parser';
const navigationObstacle2DRegistration = {
    typeName: 'NavigationObstacle2D',
    parser: parseNode2D,
};
nodeRegistry.register(navigationObstacle2DRegistration);
//# sourceMappingURL=index.js.map